import React from 'react';
import { connect } from 'react-redux';

import PageView2 from './PageView2';
import { childrenPageViews } from './pages';
import { resetOrgData, logoutFromBlumira } from '../redux/actions/Page';

import { CircularProgress } from '@material-ui/core';
import logo from '../images/blumira_login_blue.png';

const NOOP = () => <div />;

const mapStateToProps = (state) => {
  const {
    data = {},
    meta = {},
    filters = {},
    loading = false,
  } = state.page;
  const { type, payload = {}, query = {} } = state.location;
  const { orgId, toplevel = '', secondlevel = '' } = payload;
  const { error } = state.page;
  const pageConfig = childrenPageViews.find(pg=>pg.route===`${toplevel}/${secondlevel}`)
  const ChildView = pageConfig ? pageConfig.component : NOOP;

  const { dataQueries = {} } = state.dataQuery;

  return {
    ChildView,
    data,
    dataQueries,
    error,
    example: state.example,
    filters,
    loading,
    meta,
    orgId,
    payload,
    query,
    secondlevel,
    toplevel,
    type,
    theme: state.userInterface.theme,
  };
};

const mapDispatchToProps = (dispatch, getState) => ({
  routeToOrg: (props) => {
    dispatch(resetOrgData);
    dispatch({ type: props.type, payload: props.payload, query: props.query });
  },
  routeToPage: (props) => {
    dispatch({ type: 'PAGE', ...props });
  },
  routeToLogin: () => {
    dispatch(logoutFromBlumira);
  },
  dispatch,
  applyFilter: (filterKey, filterObj) => {
    dispatch({ type: 'PAGE_FILTER', filterKey, filterObj });
  },
});

const PageViewWrapper = (props) => {
  if(props.loading){
    return (
      <div className="h-100 w-100 d-flex align-items-center loading">
        <div className="row mx-auto align-items-center">
          <div className="col align-items-center mx-auto">
            <img
              className='mx-auto'
              src={logo}
              alt='Logo'
              title='Blumira'
            />
            <CircularProgress size={35} />
            <h2>Loading...</h2>
          </div>
        </div>
      </div>
    )
  } else {
    return <PageView2 {...props} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PageViewWrapper);
